import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import theme from 'theme'

import Section from 'components/page/Section'
import SubSection from 'components/page/Section/SubSection'

const StyledSection = styled(Section).withConfig({
  shouldForwardProp: (prop) => ['size'].indexOf(prop) === -1,
})`
  &&& {
    background: ${theme.colors.blues[10]};
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  a {
    text-decoration: underline !important;
    color: ${theme.colors.black} !important;
    font-weight: ${theme.fontWeights.bold} !important;

    :hover {
      color: ${theme.textColors.linkHover} !important;
    }
  }
`

export default function BlueSection ({ children, renderAs, ...others }) {
  const as = renderAs === 'SubSection' ? SubSection : Section

  return (
    <StyledSection {...others} as={as}>
      {children}
    </StyledSection>
  )
}

BlueSection.defaultProps = {
  renderAs: 'Section',
}

BlueSection.propTypes = {
  children: PropTypes.node.isRequired,
  renderAs: PropTypes.oneOf(['Section', 'SubSection']),
}
